module.exports = __webpack_public_path__ + "static/media/pencil.af482e17.svg";